import React, { useEffect } from 'react';

import {
  Main,
  Carriers,
  Plans,
  About,
  ForBrokers,
  ForEmployers,
  ForEmployees,
  ForCarriers,
} from './sections';
import { BenefitsQuoting } from '../benefitsQuoting/BenefitsQuoting';

import classes from './home.module.scss';

export const Home = () => {
  useEffect(() => {
    document.title = 'Monark Benefits Quoting Platform';
  }, []);

  return (
    <>
      <Main />
      <Carriers />
      <Plans />
      <div className={classes.HomeBrokers}>
        <ForBrokers />
        <ForCarriers />
      </div>
      <div className={classes.HomeEmployees}>
        <ForEmployers />
        <ForEmployees />
      </div>
      <BenefitsQuoting />
      <About />
    </>
  );
};
